import * as $ from 'jquery';
import './_ot-error-description.sass';
import 'webui/mui/dialog';
import { escape_html } from 'console/../utils/string';
const cache = {};
export const load_description = (ui, boiler_type, oem_errcode) => {
    // const existing = cache[boiler_type] != null ? cache[boiler_type][oem_errcode] : undefined;
    const existing = cache[boiler_type]?.[oem_errcode] ?? undefined;
    if (existing != null)
        return existing;
    let boiler_cache = cache[boiler_type];
    if (boiler_cache == null)
        cache[boiler_type] = boiler_cache = {};
    return (boiler_cache[oem_errcode] = $.Deferred(async function () {
        try {
            const json = await ui.api.opentherm_error_description(boiler_type, oem_errcode);
            this.resolve(json);
        }
        catch (error) {
            const { json } = error;
            this.reject(json);
        }
    }).promise());
};
export const prepare_description = (spec) => {
    const get_part_title = (spec) => spec.title ?? spec.element;
    const get_part_content = (spec) => {
        const html = [];
        if (spec.element != null)
            html.push(`<h2>Элемент: ${escape_html(spec.element)}</h2>`);
        html.push(get_extra(spec));
        return html.join('');
    };
    const get_extra = (spec) => {
        const html = [];
        if (spec.extra != null)
            html.push(`<p>${escape_html(spec.extra)}</p>`);
        if (spec.causes != null) {
            html.push('<p>Возможные причины:</p>');
            html.push(spec.causes);
        }
        return html.join('');
    };
    if (spec.conditional != null) {
        const more_title = 'Расшифровка ошибки котла';
        const parts = spec.conditional.map((branch) => {
            const html = [
                `<p class="ot-error-description-condition"><b>${escape_html(branch.condition)}</b></p>`,
            ];
            if (branch.title)
                html.push(`<h2>${escape_html(branch.title)}</h2>`);
            if (branch.element)
                html.push(`<h2>Элемент: ${escape_html(branch.element)}</h2>`);
            html.push(get_extra(branch));
            return html.join('');
        });
        return {
            title: spec.title,
            more_title,
            more_html: parts.join('<hr/>'),
        };
    }
    if (spec.title != null || spec.element != null) {
        const title = get_part_title(spec);
        if (spec.causes != null)
            return {
                title,
                more_title: title,
                more_html: get_part_content(spec),
            };
        else
            return { title };
    }
    return null;
};
export const short_description_html = (get_html_result) => {
    const { title, more_title, more_html } = get_html_result;
    if (title != null) {
        if (more_title != null && more_html != null) {
            return `<p>${escape_html(title)}
                        (<a href='#' class='ot-error-description-link'
                            title='${escape_html(more_title)}' content='${escape_html(more_html)}'>возможные причины</a>)</p>`;
        }
        else
            return `<p>${escape_html(title)}</p>`;
    }
    else {
        return `<p><a href='#' class='ot-error-description-link' title='${escape_html(more_title)}'
                    content='${escape_html(more_html)}'>Варианты расшифровки</a></p>`;
    }
};
export const show_dialog = (link_element) => {
    const msg = $.mui.mui_dialog.messagebox({
        width: Math.min(600, window.innerWidth - 16),
        error: true,
        title: link_element.attr('title') ?? '',
        message: link_element.attr('content') ?? '',
    });
    return msg.addClass('ot-error-dialog ot-error-dialog-maxheight');
};
